import { RootState } from "../root.reducer";
import { getLayout } from "../root.selectors";
import { createSelector } from "reselect";

export interface TopOffsetElements {
  headerHeight: number;
  primaryNavigationHeight: number;
  staticNotificationHeight: number;
  eulaHeaderHeight: number;
}

export const getHeaderHeight = createSelector(
  [getLayout],
  (layout) => layout.headerHeight
);

export const getFooterHeight = createSelector(
  [getLayout],
  (layout) => layout.footerHeight
);

export const getPrimaryNavigationHeight = createSelector(
  [getLayout],
  (layout) => layout.primaryNavigationHeight
);

export const getStaticNotificationHeight = createSelector(
  [getLayout],
  (layout) => layout.staticNotificationHeight
);

export const getEulaHeaderHeight = createSelector(
  [getLayout],
  (layout) => layout.eulaHeaderHeight
);

export const getEulaFooterHeight = createSelector(
  [getLayout],
  (layout) => layout.eulaFooterHeight
);

export const getTopOffsetElements = createSelector([getLayout], (layout) => ({
  headerHeight: layout.headerHeight,
  primaryNavigationHeight: layout.primaryNavigationHeight,
  staticNotificationHeight: layout.staticNotificationHeight,
  eulaHeaderHeight: layout.eulaHeaderHeight,
}));

export const getIsLayoutWithPrompt = (state: RootState): boolean =>
  getLayout(state).isWithPrompt;
